module.exports = __webpack_public_path__ + "img/icn-mb-cashout-inactive.8cb74f60.png";